export default {
    //R
    account:{
        /*=== add-label.vue ====*/
        trading_account_label: "Đã thêm nhãn thành công vào Tài khoản Giao dịch của bạn.",
        ok: "OK",
        add_account_label: "Thêm nhãn tài khoản",
        trading_account: "Tài khoản giao dịch",
        select_trading_id: "Chọn ID giao dịch",
        label: "Nhãn",
        alpha_numeric_characters : "Gán nhãn cho tài khoản của bạn: (Tối đa 15 chữ số)",
        apply: "Gán nhãn",
        cancel: "Hủy",
        
        /*=== change-acct-leverage.vue ====*/
        request_change_laverage: "Chúng tôi đã nhận được yêu cầu thay đổi đòn bẩy của ID giao dịch của bạn",
        from :"từ",
        to :"thành",
        confirm_mail_id:"Để xác nhận, vui lòng nhấp vào đường link xác nhận được gửi tới email bạn đã đăng ký.",
        leverage_successfully_change:"Đã xử lý yêu cầu thay đổi đòn bẩy thành công",
        change_account_leverage:"Thay đổi đòn bẩy tài khoản",
        select_trading_account :"Chọn tài khoản giao dịch",
        existing_leverage :"Đòn bẩy hiện tại",
        new_leverage :"Đòn bẩy mới",
        select_new_leverage :"Chọn đòn bẩy mới",
        change_leverage:"Thay đổi đòn bẩy",
        account_leverage_reduced :"Nếu đòn bẩy tài khoản giảm so với đòn bẩy hiện tại, ký quỹ đã sử dụng trên các giao dịch đang mở (nếu có) của bạn sẽ tăng lên.",
        
        /*=== create-account.vue ====*/
        mandatory_complete_KYC:"Bạn cần phải hoàn thành KYC trước khi tạo từ một tài khoản Trực tiếp trở lên.",
        submit_proof_address:"Vui lòng gửi tài liệu minh chứng địa chỉ bằng cách sử dụng phiếu hỗ trợ",
        click_here:"Nhấp vào đây",
        email_to: "hoặc gửi email đến",
        contactus_aaafx_com :"contactus{'@'}aaafx.com",
        following_address_Proofs: "Các bằng chứng địa chỉ sau đây được chấp nhận:",
        utility_bill: "Hóa đơn tiện ích",
        bank_statement: "Bảng sao kê ngân hàng",
        government_issued:"Tài liệu Thuế do Chính phủ phát hành",
        note:"Lưu ý",
        proof_of_address:"Minh chứng địa chỉ cần được phát hành trong vòng 4 tháng trở lại đây.",
        account :"Tài khoản",
        select_platform:"Chọn nền tảng",
        select_account_type:"Chọn loại Tài khoản",
        connect_your_account:"Bạn có muốn liên kết tài khoản của mình với ZuluTrade không?",
        select_leverage:"Chọn Đòn bẩy",
        select_account_base_currency:"Chọn Tiền tệ cơ sở của Tài khoản",
        select_currency:"Chọn tiền tệ",
        Password:"Mật khẩu",
        minimum_password_length5:"Độ dài tối thiểu của mật khẩu là 5 ký tự và phải chứa ít nhất 1 chữ cái thường, 1 chữ hoa, 1 chữ số và 1 ký tự đặc biệt.",
        minimum_password_length8:"Độ dài tối thiểu của mật khẩu là 8 ký tự và phải chứa ít nhất 1 chữ cái thường, 1 chữ hoa, 1 chữ số và 1 ký tự đặc biệt.",
        spcl_characters:"# trong số các ký tự",
        lowercase_letter:"Chữ cái thường",
        capital_letter:"Chữ in hoa",
        number: "Số",
        special_character:"Ký tự đặc biệt",
        confirm_password :"Xác nhận mật khẩu",
        trade_With_virtual_funds:"Giao dịch bằng Vốn ảo",
        test_strategies:"Kiểm tra các chiến lược miễn phí",
        risk_free_trading:"Giao dịch không rủi ro",
        live_market_feed: "Nguồn cấp tin tức thị trường trực tiếp",
        liquidity_from_top :"Thanh khoản từ các quỹ thanh khoản hàng đầu",
        effective_trading:"Công cụ giao dịch hiệu quả",
        instant_execution:"Thực hiện lệnh tức thì",
        low_commissions:"Phí hoa hồng và chên lệch thấp",
        create_new:"Tạo mới",
        
        /*=== enable-2fa.vue ====*/
        enable_2fa: "Bật Xác thực 2 yếu tố",
        click_to_enable: "Nhấn vào đây để bật",
        
        /*=== internal-transfer.vue ====*/
        received_your_request:"Chúng tôi đã nhận được yêu cầu chuyển tiền",
        from_trading_account:"từ tài khoản giao dịch của bạn",
        to_confirm:"Để xác nhận, vui lòng nhấp vào đường link xác nhận được gửi tới email đã đăng ký của bạn.",
        internal_transfer_request:"Yêu cầu chuyển khoản nội bộ của bạn từ tài khoản",
        for_amount:"với số tiền",
        to_account:"tới tài khoản",
        was_succesfull :"đã được thực hiện thành công với số tiền là",
        internal_transfer: "Chuyển tiền nội bộ",
        transfer_From: "Chuyển từ",
        transfer_to:"Chuyển từ",
        balance: "Số dư",
        enter_amount: "Nhập số tiền",
        USE_MAX:"SỬ DỤNG TỐI ĐA",
        proceed:"Tiến hành",
        Internal_Transfer_ZIP:"Chuyển khoản nội bộ không khả dụng với tài khoản ZTP.",
        In_case_of_internal_transfer:"Lưu ý: Trong trường hợp chuyển khoản nội bộ giữa các tài khoản với tiền tệ cơ sở khác nhau, số tiền chuyển khoản sẽ được tính theo giá thị trường hiện tại.",
        
        /*=== manage-account.vue ====*/
        attention :"Lưu ý - Bạn đang yêu cầu xóa ID giao dịch",
        note_after_requesting:"Note: - Sau khi yêu cầu, tài khoản của bạn sẽ bị xóa khỏi dữ liệu và bạn sẽ không thể khôi phục lại.",
        after_clicking:"Sau khi nhấp vào nút xác nhận, bạn sẽ nhận được một đường link xác nhận gửi tới email đã đăng ký để xóa tài khoản giao dịch.",
        currency: "Tiền tệ",
        Account_Type: "Loại tài khoản",
        Account_Label: "Nhãn Tài khoản",
        Bonus: "Tiền thưởng",
        Leverage: "Đòn bẩy",
        Equity: "Vốn chủ sở hữu",
        Create_Demo_Account: "Tạo Tài khoản Demo",
        Create_Live_Account :"Tạo tài khoản Trực tiếp",
        internal_transfer_CAP:"CHUYỂN KHOẢN NỘI BỘ",
        web_trading:"GIAO DỊCH TRÊN WEB",
        add_account_label_CAP:"THÊM NHÃN TÀI KHOẢN",
        change_laverage:"THAY ĐỔI ĐÒN BẨY",
        delete_account:"Xóa tài khoản",
        reset_trading_password:"ĐẶT LẠI MẬT KHẨU GIAO DỊCH",
        
        verifying_your_request: "Đang xác minh yêu cầu của bạn...",
        success: "THÀNH CÔNG",
        error: "LỖI",
        
        /*=== operations-verify.vue ====*/
        we_have_received_your_request :"Chúng tôi đã nhận được yêu cầu cài đặt lại mật khẩu Nhà đầu tư của bạn. Để xác nhận, vui lòng nhấp vào đường link xác nhận được gửi tới email đăng ký của bạn.",
        change_investor_password:"Thay đổi mật khẩu nhà đầu tư thành công.",
        reset_investor_password:"Đặt lại mật khẩu nhà đầu tư",
        investor_password:"Mật khẩu nhà đầu tư",
        master_password:"Mật khẩu chính",
        trading_iD: "ID giao dịch",
        enter_new_password:"Nhập mật khẩu mới",
        confirm_new_password :"Xác nhận mật khẩu mới",
        password_must_contain:"Mật khẩu của bạn phải chứa tối thiểu 6 ký tự và tối đa 10 ký tự, ít nhất 1 chữ số, 1 chữ in hoa và 1 ký tự đặc biệt (!@$%*)",
        change_Password:"Thay đổi mật khẩu",
        
        /*=== reset-investor-pass.vue ====*/
        reset_master_password:"Đặt lại Mật khẩu chính",
        click_reset:"Nhấp vào đây để đặt lại",
        password_caption:"Mật khẩu nhà đầu tư là mật khẩu chỉ đọc, nghĩa là không dùng để giao dịch. Nếu bạn muốn đăng nhập sử dụng Mật khẩu chính, bạn sẽ có quyền truy cập đầy đủ và có thể giao dịch trong tài khoản.",
    },
    auth: {
        /*=== corporate.vue ====*/
        corporate: "Công ty",
        account_type: "Loại tài khoản",
        select_account_type: "Chọn loại tài khoản",
        individual: "Cá nhân",
        name_of_company: "Tên công ty",
        country_of_company: "Quốc gia",
        select_company_country: "Chọn quốc gia của công ty",
        registration: "Đăng ký",
        email_company: "Email công ty",
        Password: "Mật khẩu",
        min_password_length8: "Độ dài mật khẩu tối thiểu là 8 ký tự và phải chứa ít nhất 1 chữ thường, 1 chữ in hoa, 1 số và 1 ký tự đặc biệt.",
        spcl_characters: "# của các ký tự",
        lowercase_letter: "Chữ thường",
        capital_letter: "Chữ in hoa",
        number: "Số",
        special_character: "Ký tự đặc biệt",
        confirm_password: "Xác nhận Mật khẩu",
        Phone_Number: "Số điện thoại",
        have_read: "Tôi đã đọc, hiểu và chấp nhận",
        terms_conditions: "các Điều khoản và Điều kiện",
        accept_terms_conditions: "Vui lòng chấp nhận các điều khoản và điều kiện",
        given_your_residency: "Với tư cách cư trú, bạn sẽ được tham gia vào Dịch vụ Đầu tư Chuyên gia Triple A (GR) do HCMC quản lý. Bạn có thể xem các biện pháp bảo vệ và điều khoản & điều kiện có sẵn trên trang web của chúng tôi. Bằng cách nhấp vào ",
        continue: "tiếp tục",
        triple_investment_services: "bạn đồng ý mở tài khoản với Dịch vụ Đầu tư Chuyên gia Triple A (GR).",
        register: "ĐĂNG KÝ",
        already_have_account: "Bạn đã có tài khoản?",
        login: "Đăng nhập",
        /*=== forgot-password.vue ====*/
        confirmation_link: "Một liên kết xác nhận đã được gửi đến ID email đã đăng ký của bạn. Vui lòng nhấp vào liên kết để đặt lại mật khẩu đăng nhập của bạn.",
        ok: "OK",
        this_email_address: "Địa chỉ email này không đăng ký với chúng tôi.",
        click_here: "Nhấp vào đây",
        create_account_now: "để tạo một tài khoản ngay bây giờ",
        forgot_password: "Quên mật khẩu",
        email_address: "Địa chỉ email",
        submit: "Gửi",
        dont_have_account: "Bạn chưa có tài khoản?",
        create_account_now_CAP: "TẠO MỘT TÀI KHOẢN NGAY BÂY GIỜ!",
        /*=== login.vue ====*/
        client_login: "Đăng nhập khách hàng",
        remember_me: "Nhớ tôi",
        two_step_verification: "Xác minh hai bước",
        google_authenticator: "Vui lòng nhập mật mã một lần được hiển thị trong ứng dụng Google Authenticator.",
        google_auth_code: "Mã Google Auth",
        /*=== register.vue ====*/
        sent_an_OTP: "Chúng tôi đã gửi OTP tới",
        complete_your_registration: "Vui lòng nhập mã để xác minh và hoàn tất đăng ký của bạn.",
        otp: "OTP",
        Register_heading: "Đăng ký",
        first_name: "Tên",
        last_name: "Họ",
        email: "Email",
        country: "Quốc gia",
        select_residence_country: "Chọn quốc gia cư trú",
        privacy_policy: "Chính sách bảo mật",
        accept_privacy_policy: "Vui lòng chấp nhận chính sách bảo mật",
        experts_investment_services: "Với tư cách cư trú, bạn sẽ được tham gia vào Dịch vụ Đầu tư Chuyên gia Triple A (GR) do HCMC quản lý. Bạn có thể xem các biện pháp bảo vệ và điều khoản & điều kiện có sẵn trên trang web của chúng tôi. Bằng cách nhấp vào ",
        opening_your_account: "bạn đồng ý mở tài khoản với Dịch vụ Đầu tư Chuyên gia Triple A (GR).",
        /*=== reset-password.vue ====*/
        login_password_change: "Mật khẩu đăng nhập của bạn đã được thay đổi thành công.",
        reset_password: "Đặt lại mật khẩu",
        reset: "Đặt lại",
    },
    //H
    copy_trading: {
        copy_trading: "Sao chép giao dịch",
        copy_trading_header: "Kiếm lợi nhuận bằng cách tự động sao chép các giao dịch của nhà quản lý chiến lược",
        leading_traders: "TỰ ĐỘNG SAO CHÉP CÁC NHÀ GIAO DỊCH HÀNG ĐẦU",
        diversified_trading: "DANH MỤC GIAO DỊCH ĐA DẠNG",
        monitor_profit: "GIÁM SÁT & KIẾM LỜI",
        copy_traders: "LÀM THẾ NÀO ĐỂ SAO CHÉP GIAO DỊCH?",
        one: "1.",
        one_header: "Mở một tài khoản Trực tiếp và nạp tiền.",
        two: "2.",
        two_header: "Chọn một nhà Quản lý chiến lược.",
        three: "3.",
        three_header: "Đồng ý với các điều khoản và điều kiện.",
        four: "4.",
        four_header: "Cung cấp cho chúng tôi thỏa thuận của bạn.",
        five: "5.",
        five_header: "Kiếm lợi nhuận bằng cách sao chép giao dịch.",
        order_processing: "XỬ LÝ LỆNH NHANH",
        end_result: "KIỂM SOÁT KẾT QUẢ CUỐI CÙNG",
        trading_skills: "NÂNG CẤP KỸ NĂNG GIAO DỊCH CỦA BẠN",
        start: "Bắt đầu"
    },
    downloads: {
        mt_four_desktop: "MT4 cho Desktop",
        mt_four_android: "MT4 cho Android",
        mt_four_ios: "MT4 cho iOS",
        mt_four_web_trader: "MT4 Web Trader",
        mt_five_desktop: "MT5 cho Desktop",
        mt_five_android: "MT5 cho Android",
        mt_five_ios: "MT5 cho iOS",
        mt_five_web_trader: "MT5 Web Trader",
        act_trader_desktop: "Act Trader cho Desktop",
        act_trader_android: "Act Trader cho Android",
        act_trader_ios: "Act Trader cho iOS",
        act_web_trader: "Act Web Trader"
    },
    tools_index: {
        avail_vps: "Bạn có chắc chắn muốn sử dụng",
        package: "Gói VPS?",
        yes: "Đúng",
        no: "KHÔNG",
        downloads: "Tải về",
        copy_trading: "Sao chép giao dịch",
        vps: "VPS"
    },
    vps: {
        vps_plans: "Các gói VPS",
        bronze: "ĐỒNG",
        monthly_subscription_twenty_five: "Đăng ký hàng tháng $25",
        free_deposit_five_thousand: "Nhận miễn phí khi nạp tiền từ $5.000 trở lên",
        compatible_mt_four_five_act: "Tương thích với MT4, MT5 và Act",
        free_twenty_five_gb_disk_space_ram_vcpu: "Miễn phí Dung lượng ổ 25 GB | 1300 MB RAM | 1 VCPU",
        windows_linux_support: "Phù hợp với Windows 8/10/12, Linux",
        avail_now: "Sử dụng ngay",
        silver: "BẠC",
        monthly_subscription_fourty_five: "Đăng ký hàng tháng $45",
        free_on_deposit_ten_thousand: "Nhận miễn phí khi nạp $10.000 trở lên",
        free_fifty_gb_disk_space_ram_vcpu: "Miễn phí Dung lượng ổ 50 GB | 2700 MB RAM | 2 VCPU",
        gold: "VÀNG",
        monthly_subscription_eighty: "Đăng ký hàng tháng $80",
        free_on_deposit_fifteen_thousand: "Nhận miễn phí khi nạp tiền từ $15.000 trở lên",
        free_seventy_five_gb_disk_space_ram_vcpu: "Miễn phí Dung lượng ổ 75 GB | 5120 MB RAM | 3 VCPU"
    },
    ticket_details: {
        cancel_withdrawal_request: "Hủy yêu cầu rút tiền",
        cancel_your_withdrawal_request: "Bạn có chắc chắn muốn hủy Yêu cầu rút tiền của mình không",
        process_request: "Xử lý Yêu cầu",
        open_tickets: "Mở Phiếu yêu cầu",
        back: "Quay lại",
        ticket_number: "Số phiếu yêu cầu:",
        created: "Đã tạo:",
        reason: "Reason:"
    },
    bonus: {
        request_to_avail_bonus: "Yêu cầu sử dụng tiền thưởng của bạn",
        trading_id: "cho ID giao dịch",
        click_confirmation_link: "đã được ghi nhận. Để xác nhận, vui lòng nhấp vào liên kết xác nhận được gửi đến email ID đã đăng ký của bạn.",
        request_to_remove_bonus: "Yêu cầu loại bỏ tiền thưởng của bạn",
        bonus_amount: "Số tiền thưởng",
        successfully_removed_account: "đã được gỡ bỏ thành công khỏi id tài khoản",
        ok: "OK",
        request_to_add_bonus: "Yêu cầu thêm tiền thưởng của bạn",
        successfully: "đã thành công.",
        bonus: "TIỀN THƯỞNG",
        select_trading_id: "Chọn ID giao dịch",
        use_max: "Sử dụng Max",
        account_type: "Loại tài khoản",
        equity: "Vốn chủ sở hữu",
        leverage: "Đòn bẩy",
        currency: "Tiền tệ",
        current_bonus: "Tiền thưởng hiện tại",
        allowed_bonus: "Tiền thưởng được phép",
        remove: "Gỡ bỏ",
        account_first: "Vui lòng chọn một tài khoản trước",
        bonus_amount_base_currency: "Lưu ý: Nhập số tiền thưởng bằng đơn vị tiền tệ cơ sở.",
        point_one: "1. Ưu đãi thưởng 100% của chúng tôi dành cho tất cả khách hàng nạp tiền tối thiểu là 100 USD và đòn bẩy tài khoản lên đến 1:200. Tiền thưởng tối đa được phép là 40.000 USD cho mỗi khách hàng.",
        point_two: "2. Tất cả lợi nhuận kiếm được từ các giao dịch bằng tiền thưởng của chúng tôi sẽ là của bạn. Tiền thưởng sẽ không được lấy ra nếu bạn rút lợi nhuận của mình.",
        point_three: "3. Tiền thưởng tăng số tiền ký quỹ có sẵn của bạn trong tài khoản. Tuy nhiên, tổn thất của bạn không thể được tính vào tiền thưởng. Nếu tổng số lỗ trên các giao dịch của bạn vượt quá số tiền của bạn, hệ thống sẽ tự động dừng các vị trí trong tài khoản giao dịch của bạn mà không cần thông báo trước.",
        point_four: "4. Số tiền thưởng tương ứng sẽ được lấy ra từ tài khoản của bạn nếu bạn rút tiền của chính mình.",
        read_understood_accepted: "Tôi đã đọc, hiểu và chấp nhận",
        aaafx_bonus_policy: "Chính sách thưởng AAAFx.",
        accept_aaafx_bonus_policy: "Vui lòng chấp nhận chính sách thưởng AAAFx",
        proceed: "Tiến hành",
        no_bonus_available_account: "Không có phần thưởng khả dụng cho tài khoản này"
    },
    refer_earn: {
        bonus: "TIỀN THƯỞNG",
        refer_earn: "GIỚI THIỆU VÀ KIẾM TIỀN",
        refer_friend: "Giới thiệu một người bạn",
        earn_dollar_twenty_five: "Nhận ngay $25",
        per_friend: "cho mỗi người bạn giới thiệu",
        why_refer_someone_to_us: "Tại sao bạn nên giới thiệu ai đó cho chúng tôi?",
        refer_someone_point_one: "1. Bạn và bạn bè của bạn đều nhận được lợi ích của tiền thưởng giới thiệu.",
        refer_someone_point_two: "2. Một thủ tục đơn giản và nhanh chóng",
        refer_someone_point_three: "3. Cả hai đều được hưởng lợi từ các điều kiện giao dịch thuận lợi của chúng tôi.",
        refer_someone_point_four: "4. Thu nhập từ giới thiệu là vô hạn.",
        what_need_to_do: "Đây là những gì bạn cần làm:",
        what_need_to_do_point_one: "1. Chia sẻ liên kết giới thiệu của bạn với người quen của bạn.",
        what_need_to_do_point_two: "2. Người bạn giới thiệu đăng ký bằng liên kết của bạn và bắt đầu giao dịch.",
        what_need_to_do_point_three: "3. Ngay sau khi đạt đủ điều kiện, mỗi người sẽ nhận được 25 đô la.",
        referral_list: "Danh sách giới thiệu của bạn"
    },
    referral_list: {
        referrals_list: "Danh sách giới thiệu",
        list_of_referrals: "Danh sách các giới thiệu để theo dõi thu nhập của bạn.",
        s_no: "S.No.",
        name: "Tên",
        email_id: "Email ID",
        account_stage: "Trạng thái tài khoản",
        deposits: "Tiền nạp",
        volume_required: "Khối lượng cần thiết",
        traded_volume: "Khối lượng giao dịch",
        qualified: "Đủ điều kiện",
        no_data: "Không có dữ liệu",
        payment_of_referral_bonus: "Việc thanh toán Tiền thưởng Giới thiệu sẽ được thực hiện trong tuần tiếp theo tuần mà Người được giới thiệu đã đủ điều kiện.",
        referral_bonus_paid_in_aaafx_wallet: "Tiền thưởng Giới thiệu sẽ được thanh toán bằng ví AAAFx USD mà Người giới thiệu và Người được giới thiệu có thể rút hoặc chuyển tiền vào tài khoản giao dịch của họ.",
        read_all_terms_conditions: "Đọc tất cả các Điều khoản và Điều kiện",
        here: "ở đây",
        contact_us: "Bạn có câu hỏi? Liên hệ với chúng tôi tại Live Chat 24/5 hoặc gửi thư cho chúng tôi tại",
        customer_care: "customercare{'@'}aaafx-international.com",
        definitions: "Định nghĩa",
        meaning_of_all_above_columns: "Dưới đây là ý nghĩa của tất cả các cột trên để bạn tham khảo:",
        name_of_your_referral: "- Tên người bạn giới thiệu.",
        meaning_of_various_stages: "- Vui lòng xem ý nghĩa bên dưới của các trạng thái khác nhau.",
        registered: "1. Đã đăng ký:",
        registered_link: "Người được giới thiệu của bạn đã đăng ký bằng liên kết của bạn.",
        funded: "2. Đã nạp tiền:",
        referral_deposited: "Người bạn giới thiệu đã nạp tiền.",
        third_point_qualified: "3. Đủ điều kiện:",
        referral_has_deposited: "Người bạn giới thiệu đã nạp tiền và đạt khối lượng giao dịch yêu cầu. Cả hai đều đủ điều kiện nhận phần thưởng.",
        deposits_made_by_referral: "- Tiền nạp được thực hiện bởi người bạn giới thiệu.",
        volume_requirement: "Yêu cầu khối lượng",
        volume_required_for_reward: "- Khối lượng cần thiết để Người bạn giới thiệu đủ điều kiện nhận phần thưởng.",
        volume_your_referral_traded: "- Khối lượng mà Người bạn giới thiệu đã thực sự giao dịch.",
        referral_qualified_for_reward: "- Cho dù Người bạn giới thiệu đã đủ điều kiện cho yêu cầu phần thưởng hay chưa.",
        referral_ib_programs: "Sau khi nhận được phần thưởng cho 10 người đã giới thiệu, bạn có thể trở thành IB hoặc tiếp tục chương trình Giới thiệu và Kiếm tiền với phần thưởng $20 cho bạn và người bạn giới thiệu. Bạn có thể so sánh lợi ích và đặc điểm của chương trình Giới thiệu và IB"
    },
    calculators_common: {
        asset_class: "Loại tài sản",
        forex: "Forex",
        commodities: "Hàng hóa",
        indices: "Chỉ số",
        account_base_currency: "Tiền tệ cơ sở của tài khoản",
        usd: "USD",
        gbp: "GBP",
        aud: "AUD",
        eur: "EUR",
        symbol: "Biểu tượng",
        select_symbol: "Chọn biểu tượng",
        trade_size_in_lots: "Quy mô giao dịch (tính theo lô)",
        calculate: "Tính toán"
    },
    margin: {
        margin_required: "Yêu cầu ký quỹ:",
        maximum_leverage: "Đòn bẩy tối đa:"
    },
    pip: {
        pip_value: "Giá trị pip:"
    },
    swap: {
        server: "Máy chủ",
        mt_four_five: "MT4/MT5",
        act_trader: "Act Trader",
        no_of_days: "Số ngày",
        long_swap: "Phí qua đêm mua:",
        short_swap: "Phí qua đêm bán:"
    },
    //S
    dashboard:{
        select_trading_id: "Chọn ID giao dịch",
        leverage: "Đòn bẩy",
        balance: "Số dư",
        equity: "Vốn chủ sở hữu",
        free_margin: "Ký quỹ còn dư",
        pnl: "PNL",
        web_trader : "Web Trader",
        fund: "Nguồn vốn",
        promotions: "Chương trình khuyến mãi",
        hundred: "100",
        bonus: "Tiền thưởng",
        avail: "Sử dụng",
        deposit_bonus: "Tiền thưởng nạp tiền",
        loading_initial_data: "Đang tải dữ liệu ban đầu",
    },
    enable_2fa:{
        title: "Google Authentication (2FA)",
        description: "Để bật Xác thực hai yếu tố của Google (2FA), hãy quét mã QR và nhập mật mã một lần đã tạo bên dưới.",
        google_authenticator_code: "Mã Google Authenticator",
        how_to_enable: "Để bật Xác thực 2 yếu tố:",
        download: "Tải về",
        google_authenticator_app: "Ứng dụng Google Authenticator",
        on_mobile_tablet: "trên điện thoại di động/máy tính bảng của bạn.",
        scan_the : "Quét",
        qr_code: "Mã QR",
        appearing_above: "xuất hiện ở trên",
        enter_the: "Nhập",
        passcode: "Mật mã",
        appers_in_google_auth_app: "xuất hiện trong Ứng dụng Google Authenticator của bạn",
        click_on_the_button: "Nhấp vào nút",
        click_to_enable: "Nhấn vào đây để bật",
    },
    account_security:{
        title: "Google Authentication (2FA)",
        description: "Để bật Xác thực hai yếu tố của Google (2FA), hãy quét mã QR và nhập mật mã một lần đã tạo bên dưới.",
        google_authenticator_code: "Mã Google Authenticator",
        how_to_enable: "Để bật Xác thực 2 yếu tố:",
        download: "Tải về",
        google_authenticator_app: "Ứng dụng Google Authenticator",
        on_mobile_tablet: "trên điện thoại di động/máy tính bảng của bạn.",
        scan_the : "Quét",
        qr_code: "Mã QR",
        appearing_above: "xuất hiện ở trên",
        enter_the: "Nhập",
        passcode: "Mật mã",
        appers_in_google_auth_app: "xuất hiện trong Ứng dụng Google Authenticator của bạn",
        click_on_the_button: "Nhấp vào nút",
        click_to_enable: "Nhấn vào đây để bật",
    },
    change_pass:{
        success_message:"Your Password has been changed successfully.",
        ok:"OK",
        change_password: "Đổi mật khẩu",
        existing_password: "Mật khẩu hiện tại",
        new_password: "Mật khẩu mới",
        confirm_new_password: "Xác nhận mật khẩu mới",
        note_one: "Mật khẩu phải chứa tối thiểu 7 và tối đa 10 ký tự và phải bao gồm ít nhất 1 số, 1 chữ hoa và 1 ký tự đặc biệt {'(! @#$%^) '}.",
        note_two: "Xin lưu ý rằng mật khẩu hồ sơ khác với mật khẩu tài khoản giao dịch của bạn",
        cancel: "Hủy",
    },
    corporate_varify_step_three:{
        please_upload_file: "Vui lòng tải lên tập tin",
        out_of_documents: "trong số 8 tài liệu",
        add_file: "Thêm tập tin",
        max_file_size: "Kích thước tệp tối đa lên tới"
    },
    corporate_varify:{
        corporation_info: 'Thông tin công ty',
        account_creation: "Tạo tài khoản",
        verification: "Xác minh",
        deposit: "Nạp tiền",
        select_platform: "Chọn nền tảng",
        select_account_type: "Chọn loại tài khoản",
        select_leverage: "Chọn Đòn bẩy",
        select_base_currency: "Chọn Đơn vị tiền tệ cơ sở của tài khoản",
        select_currency: "Chọn loại tiền tệ",
        password: "Mật khẩu",
        pass_length_alert: "Độ dài mật khẩu tối thiểu là 5 ký tự và phải chứa ít nhất 1 chữ thường, 1 chữ in hoa 1 số và 1 ký tự đặc biệt.",
        of_characters: "của các ký tự",
        lowercase_letter: 'Chữ cái thường',
        capital_letter : "Chữ in hoa",
        number: "Số",
        special_character : "Ký tự đặc biệt",
        confirm_password: "Xác nhận Mật khẩu",
        create_account : "Tạo tài khoản",
    },
    corporation_info:{
        name_of_company: "Tên công ty",
        country_of_company: "Quốc gia",
        select_company_country: "Chọn quốc gia của công ty",
        registration: "Đăng ký",
        submit: "GỬI",
    },
    profile:{
        personal_details: "Thông tin cá nhân",
        uploaded_documents: "Tài liệu đã tải lên",
        no_documents_yet: "Chưa có tài liệu",
    },
    questions:{
        financial_details: "Thông tin tài chính",
        sub_heading_one: "Tổng thu nhập ước tính hàng năm",
        select_annual_income: "Chọn Thu nhập hàng năm",
        sub_heading_two: "Tổng giá trị ròng ước tính",
        sub_heading_two_desc: "Tổng tài sản trừ đi tổng nợ phải trả của một cá nhân hoặc một công ty.",
        select_net_worth:"Chọn giá trị ròng",
        sub_heading_three: "Ngành nghề",
        select_occupation: "Chọn nghề nghiệp",
        sub_heading_four: "Nhập nghề nghiệp khác",
        sub_heading_five: "Nguồn vốn",
        sub_heading_six: "Nhập các nguồn vốn khác",
        sub_heading_seven: "Người được báo cáo của FATCA Hoa Kỳ",
        sub_heading_eight: "Quốc gia/Thẩm quyền cư trú thuế",
        select_residence_country: "Chọn quốc gia cư trú",
        sub_heading_nine: "Bạn có số TIN không?",
        sub_heading_ten: "Nhập số TIN",
        sub_heading_eleven: "Nếu không có TIN, hãy nhập Lý do",
        select_reasons: "Chọn lý do",
        enter_reason: "Nhập lý do",
        submit: "Gửi",
        dear: "Thân gửi",
        message_one: "Dựa trên thông tin bạn đã cung cấp, có vẻ như bạn là cư dân Hoa Kỳ vì mục đích thuế.",
        message_two: "Xin lưu ý rằng do Tuân thủ Quy định của chúng tôi, AAAFx không thể chấp nhận khách hàng là cư dân Hoa Kỳ vì mục đích thuế.",
        message_three: "Cảm ơn bạn đã thông cảm cho chúng tôi.",
        message_four: "Trân trọng,",
        message_five: "AAAFx",
        close: "Đóng",
    },
    verify:{
        account_creation: "Tạo tài khoản",
        financial_details: "Thông tin tài chính",
        verification: "Xác minh",
        deposit: "Nạp tiền",
        select_platform: "Chọn nền tảng",
        select_account_type: "Chọn loại tài khoản",
        select_leverage: "Chọn Đòn bẩy",
        select_base_currency: "Chọn Đơn vị tiền tệ cơ sở của tài khoản",
        select_currency: "Chọn loại tiền tệ",
        password: "Mật khẩu",
        pass_message_one: "Độ dài mật khẩu tối thiểu là 5 ký tự và phải chứa ít nhất 1 chữ thường, 1 chữ in hoa 1 số và 1 ký tự đặc biệt.",
        pass_message_two: "Độ dài mật khẩu tối thiểu là 8 ký tự và phải chứa ít nhất 1 chữ thường, 1 chữ in hoa, 1 số và 1 ký tự đặc biệt.",
        of_characters: "của các ký tự",
        lowercase_letter: "Chữ thường",
        capital_letter: "Chữ in hoa",
        number: "Số",
        special_character: "Ký tự đặc biệt",
        confirm_password: "Xác nhận Mật khẩu",
        create_account: "Tạo tài khoản",
        doc_message_one: "Các tài liệu bạn gửi đã bị từ chối bởi quy trình xác minh tự động. Một phiếu yêu cầu tương tự đã được tạo để bạn có thể tải lại tài liệu của mình để chúng tôi xác minh tài liệu theo cách thủ công nếu bạn muốn.",
        view_ticket: "Xem phiếu",
    },
    verify_quest_bkp:{
        account_creation: "Tạo tài khoản",
        questionnaire: "bảng câu hỏi",
        verification: "Xác minh",
        deposit:"Deposit",
        select_platform: "Chọn nền tảng",
        select_account_type: "Chọn loại tài khoản",
        select_leverage: "Chọn Đòn bẩy",
        select_base_currency: "Chọn Đơn vị tiền tệ cơ sở của tài khoản",
        select_currency: "Chọn loại tiền tệ",
        password: "Mật khẩu",
        pass_length_alert: "Độ dài mật khẩu tối thiểu là 5 ký tự và phải chứa ít nhất 1 chữ thường, 1 chữ in hoa 1 số và 1 ký tự đặc biệt.",
        of_characters: "của các ký tự",
        lowercase_letter: "Chữ thường",
        capital_letter: "Chữ in hoa",
        number: "Số",
        special_character: "Ký tự đặc biệt",
        confirm_password: "Xác nhận Mật khẩu",
        create_account: "Tạo tài khoản",
        doc_message_one: "Các tài liệu bạn gửi đã bị từ chối bởi quy trình xác minh tự động. Một phiếu yêu cầu tương tự đã được tạo để bạn có thể tải lại tài liệu của mình để chúng tôi xác minh tài liệu theo cách thủ công nếu bạn muốn.",
        view_ticket: "Xem phiếu",
    },
    close_ticket:{
        heading: "Phiếu đã đóng",
        create_request: "TẠO YÊU CẦU",
        open_tickets: "MỞ PHIẾU",
        ticket_number: "Số phiếu",
        trading_id: "ID giao dịch",
        status: "Trạng thái",
        subject: "Chủ đề",
        created: "Đã tạo",
        closed: "Đã đóng",
        action: "Hành động",
        view_ticket: "Xem phiếu",
        no_tickets_found: "Không tìm thấy phiếu",
    },
    open_ticket:{
        heading: "Mở Phiếu yêu cầu",
        create_request: "TẠO YÊU CẦU",
        open_tickets: "MỞ PHIẾU",
        closed_ticket: "Phiếu đã đóng",
        ticket_number: "Số phiếu",
        trading_id: "ID giao dịch",
        status: "Trạng thái",
        subject: "Chủ đề",
        created: "Đã tạo",
        action: "Hành động",
        view_ticket: "Xem phiếu",
        no_tickets_found: "Không tìm thấy phiếu",
    },
    request_call:{
        success_message:"Yêu cầu gọi lại của bạn đã được ghi nhận. Chúng tôi sẽ sớm liên lạc với bạn.",
        ok: "OK",
        request_call_back:"Yêu cầu gọi lại",
        first_name: "Tên",
        last_name: "Họ",
        email_id: "Email ID",
        phone_number: "Số điện thoại",
        timezone: "Múi giờ",
        date: "Ngày",
        preferred_time: "Thời gian ưa thích",
        department: "Bộ phận",
        select_department: "Chọn bộ phận",
        new_accounts: "Tài khoản mới",
        deposits: "Tiền nạp",
        withdrawals: "Tiền rút",
        partnership: "Quan hệ đối tác",
        technical_support: "Hỗ trợ kỹ thuật",
        message: "Tin nhắn",
        send_request: "Gửi yêu cầu",
    },
    support_page:{
        success_message:"Phiếu hỗ trợ dành cho bạn đã được khởi tạo thành công. Bạn có thể theo dõi phiếu trong mục Phiếu đã mở.",
        ok:"OK",
        support: "Hỗ trợ",
        create_req:"TẠO YÊU CẦU",
        open_tickets:"PHIẾU ĐÃ MỞ",
        closed_tickets: "PHIẾU ĐÃ ĐÓNG",
        otp_msg:"Chúng tôi đã gửi một mã OTP tới email đăng ký của bạn. Vui lòng nhập mã đó để xác nhận yêu cầu phiếu hỗ trợ.",
        otp: "OTP",
        submit: "Gửi",
        reason: "Lý do",
        select_a_reason: "Chọn một lý do",
        trading_id: "ID giao dịch",
        select_trading_account: "Chọn Tài khoản Giao dịch",
        subject: "Chủ đề",
        trade_order_id: "ID lệnh giao dịch",
        time_of_trade_opening: "Thời gian mở giao dịch",
        time_of_trade_closing: "Thời gian đóng giao dịch",
        instrument_traded: "Công cụ đã giao dịch",
        type_of_trade: "Loại giao dịch",
        select_trade_type: "Chọn Loại giao dịch",
        details_of_the_issue: "Chi tiết về vấn đề",
        refund_claim_amount: "Số tiền yêu cầu hoàn lại",
        message: "Tin nhắn",
        note: "GHI CHÚ",
        file_attachments: "Tệp đính kèm",
        file_size_msg: "Kích thước của tài liệu không được lớn hơn 1MB",
        file_format_msg: "Chỉ định dạng tệp (jpeg hoặc pdf)",
        lowercase_note: "Lưu ý",
        note_desc: "Trong trường hợp có bất kỳ lỗi nào trong khi thực hiện bất kỳ thao tác tài khoản nào, vui lòng đính kèm ảnh chụp màn hình trong khi tạo phiếu",
        create_support_request: "Tạo yêu cầu hỗ trợ",
    },
    become_ib:{
        heading: "Nhà môi giới Giới thiệu (IB)",
        description: "Tăng thu nhập của bạn với Chương trình IB của chúng tôi. <br />Nhận liên kết riêng của bạn, chia sẻ với bạn bè và kiếm hoa hồng bất cứ khi nào họ giao dịch.",
        sub_heading: "Chúng tôi cung cấp hai loại chương trình IB:",
        point_one: "Chương trình IB tiêu chuẩn- Ngay lập tức nhận được 20% thu nhập hoa hồng của chúng tôi từ khách hàng của bạn. Phù hợp với một IB mới bắt đầu, những người muốn bắt đầu lại hoặc mang lại một số lượng khách hàng có hạn cho chúng tôi.",
        point_two: "Chương trình IB nâng cao- Đây là một chương trình IB lợi nhuận cao và tùy chỉnh cho các IB lớn hơn của chúng tôi. Phù hợp với những người có cơ sở dữ liệu khách hàng đáng kể, có thể mang lại khối lượng giao dịch lớn hơn.",
        note_one: "Bạn có thể chuyển từ Chương trình IB Tiêu chuẩn sang Chương trình IB Nâng cao, một khi bạn đã có một mạng lưới đủ lớn.",
        earn_with: "Kiếm tiền mà",
        zero_investment_or: "không cần tiền đầu tư hoặc",
        experience: "kinh nghiệm",
        weekly_ib: "IB hàng tuần",
        commissions: "Hoa hồng",
        payouts: "thanh toán",
        unlimited: "Không giới hạn",
        earnings: "thu nhập",
        potential: "tiềm năng",
        sub_cont_point_four: "Chương trình IB nâng cao được tùy chỉnh và lợi nhuận cao",
        ultra_fast: "Siêu nhanh",
        withdrawals_of_ib: "rút tiền",
        commission: "hoa hồng IB",
        easy_user: "Dễ sử dụng",
        interface_of: "giao diện người dùng",
        ib_portal: "cổng IB",
        dedicated: "Chuyên biệt",
        account: "Nhà quản lý",
        manager: "Tài khoản",
        helpful_and: "Hữu ích và",
        free_marketing: "Miễn phí",
        material: "Tài liệu tiếp thị",
        become_an_ib: "Trở thành IB",
    },
    pamm_acct:{
        title:"TÀI KHOẢN PAMM",
        description_one: "PAMM (Percentage Allocation Management Module) là một tài khoản quản lý trong đó người quản lý thực hiện các giao dịch trong tất cả các tài khoản phụ của nó. Người quản lý và Nhà đầu tư được tự do lựa chọn cấu trúc phí thực hiện và chúng tôi sẽ đảm nhận việc áp dụng nó.",
        description_two: "AAAFx cung cấp các giải pháp giao dịch PAMM rất linh hoạt và tùy chỉnh.",
        sub_title: "Cách đăng ký làm Quản lý PAMM",
        sub_Point_one: "Tài khoản Người quản lý PAMM của bạn có thể được mở khi bạn có ít nhất bốn nhà đầu tư với tổng số tiền nạp từ 5.000 đô la trở lên.",
        sub_Point_two: "Chỉ cần đăng ký làm IB để trở thành Quản lý PAMM với chúng tôi. Nhận khách hàng của bạn đăng ký bằng liên kết IB của bạn, đáp ứng điều kiện đầu tiên ở trên.",
        sub_Point_three: "Liên hệ với chúng tôi qua Trò chuyện trực tiếp hoặc gửi email cho chúng tôi theo địa chỉ",
        sub_Point_four: "Bắt đầu kiếm hoa hồng IB ngoài Phí thực hiện PAMM.",
        minimul_investment: "ĐẦU TƯ TỐI THIỂU",
        ease_of_access: "TRUY CẬP DỄ DÀNG",
        ultimate_trading_conditions: "ĐIỀU KIỆN GIAO DỊCH TUYỆT VỜI",
        trade_security: "GIAO DỊCH AN TOÀN",
        request_pamm: "Yêu cầu PAMM",
    },
    add_payment_methods:{
        success_message: "Phương thức thanh toán của bạn đã được thêm thành công. Bạn có thể theo dõi nó trong mục Mở Phiếu yêu cầu.",
        ok: "OK",
        otp_message: "Chúng tôi đã gửi một mã OTP đến email đăng ký của bạn. Vui lòng nhập mã đó để xác minh yêu cầu phiếu hỗ trợ.",
        otp: "OTP",
        submit: "Gửi",
        page_heading: "Thêm phương thức thanh toán",
        select_payment_method: "Chọn Phương thức thanh toán",
        select_method: "Chọn phương thức",
        bank: "Ngân hàng",
        credit_card: "Thẻ tín dụng",
        crypto: "Tiền điện tử",
        select_crypto_currency: "Chọn Tiền tệ tiền điện tử",
        select_crypto: "Chọn Tiền điện tử",
        btc: "BTC",
        eth: "ETH",
        usdt: "USDT",
        usdc: "USDC",
        add_your_bank_details: "Thêm thông tin ngân hàng của bạn",
        bank_name: "Tên ngân hàng",
        account_name: "Tên tài khoản",
        account_number: "Số tài khoản",
        country: "Quốc gia",
        select_country: "Chọn quốc gia",
        iban: "IBAN",
        iban_note: "Ngân hàng của tôi không phát hành IBAN",
        swift: "Swift",
        bic: "BIC",
        sort_code: "Mã sort",
        bank_address: "Địa chỉ ngân hàng",
        upload_your_bank_statement: "Tải lên bảng sao kê ngân hàng của bạn",
        upload_doc_info_one: "Kích thước của tài liệu không được lớn hơn 1MB",
        upload_doc_info_two: "Chỉ định dạng tệp (jpeg hoặc pdf)",
        note: "Lưu ý",
        note_msg: "Trong trường hợp có bất kỳ lỗi nào trong khi thực hiện bất kỳ thao tác tài khoản nào, vui lòng đính kèm ảnh chụp màn hình trong khi tạo phiếu",
        create_support_request: 'Tạo yêu cầu hỗ trợ',
        add_your_card_details: "Thêm thông tin thẻ của bạn",
        creadit_card_number: "Số thẻ tín dụng của bạn",
        month: "Tháng",
        zero_one: "01",
        zero_two: "02",
        zero_three: "03",
        zero_four: "04",
        zero_five: "05",
        zero_six: "06",
        zero_seven: "07",
        zero_eight: "08",
        zero_nine: "09",
        ten: "10",
        eleven: "11",
        twelve: "12",
        year: "Năm",
        two_thousand_twenty: "2020",
        two_thousand_twentyone: "2021",
        two_thousand_twentytwo: "2022",
        two_thousand_twentytree: "2023",
        two_thousand_twentyfour: "2024",
        two_thousand_twentyfive: "2025",
        two_thousand_twentysix: "2026",
        two_thousand_twentyseven: "2027",
        two_thousand_twentyeight: "2028",
        two_thousand_twentynine: "2029",
        two_thousand_thirty: "2030",
        cvv: "CVV",
        varification_msg: "Chúng tôi yêu cầu những thông tin sau đây để xác minh thẻ",
        varification_msg_one: "Bản sao màu mặt trước của thẻ, hiển thị: tên đầy đủ, ngày hết hạn, tên/logo ngân hàng, 4 chữ số đầu tiên và 4 chữ số cuối của số thẻ tín dụng, ẩn 8 chữ số ở giữa.",
        upload_supporting_document: "Tải lên tài liệu hỗ trợ",
        varification_msg_two: "Bản sao màu của mặt sau của thẻ ẩn mã bảo mật CVV. Bản sao mặt sau phải hiển thị chữ ký của chủ sở hữu",
        add_selected_crypto_address: "Thêm địa chỉ tiền điện tử đã chọn",
        address: "Địa chỉ",
    },
    deposit:{
        account_type: "Loại tài khoản",
        select_type: "Chọn loại",
        live: "Trực tiếp",
        trading_account: "Tài khoản giao dịch",
        select_trading_account: "Chọn Tài khoản Giao dịch",
        balance: "Số dư",
        fund: "NẠP TIỀN",
        amount: "Số tiền",
        region: "Khu vực",
        currencies: "Tiền tệ",
        processing_time: "Thời gian xử lý",
        action: "Hành động",
        view_more: "Xem thêm",
        currency: "Tiền tệ",
        zar: "ZAR",
        swift_code: "Mã Swift",
        beneficiarys_name: "Tên người thụ hưởng",
        beneficiarys_name_des: "SIKHULA VENTURE CAPITAL (PTY) LTD",
        account_number: "Số tài khoản",
        user_account_number: "62928423269",
        bank_address: "Địa chỉ ngân hàng",
        bank_address_info: "Mybranch Forum 1, Tầng 4, 33 Hoofd Str, Braampark",
        dixipay: "Dixipay",
        bank_name: "Tên ngân hàng",
        bank_name_info: "DIXIPAY LTD",
        swift_code_info: "DIXPGB21",
        beneficiarys_name_info: 'Alpha Global Limited',
        iban: "IBAN",
        iban_no: "GB78DIXP00997890200462",
        eur: "EUR",
        city: "Thành phố",
        city_info: "London",
        country: "Quốc gia",
        country_info: "Vương quốc Anh",
        dixipay_note: "Dixipay chỉ chấp nhận tiền nạp bằng EURO",
        you_can_deposit: "Bạn có thể nạp tiền",
        you_can_deposit_msg: "vào địa chỉ sau và số tiền tương đương bằng đơn vị tiền tệ tài khoản đã chọn sẽ được thêm vào sau khi chuyển đổi",
        copy: "Sao chép",
        done: "Xong",
        network_msg: "Mạng ERC-20 (USDT, USDC, ETH) được hỗ trợ, việc sử dụng bất kỳ mạng nào khác sẽ không đến được điểm cuối của chúng tôi.",
    },
    fund_index: {
        add_funds: "Thêm tiền",
        cancel: "Hủy",
        ok: "OK",
        your_request_to_add: "Yêu cầu thêm tiền",
        to_your_demo_account_number: "vào Số tài khoản Demo của bạn",
        has_been_successfully_completed: "đã được thực hiện thành công",
        your_request_to_withdraw: "Yêu cầu rút tiền của bạn",
        from_the_trading_id: "từ ID giao dịch",
        has_been_received: "đã được ghi nhận",
        click_to_proceed_withdrawal: "Vui lòng nhấp vào liên kết xác nhận được gửi đến ID email đã đăng ký của bạn để xử lý việc rút tiền",
        has_been_successfully: "đã thành công",
        your_request_to_add_usd: "Yêu cầu thêm USD của bạn",
    },
    request_verify: {
        verifying_your_request: "Đang xác minh yêu cầu của bạn",
        success: "THÀNH CÔNG",
        go_to_transactions: "Đi tới Giao dịch",
        error: "LỖI",
    },
    transactions: {
        list_of_transactions: "Danh sách các giao dịch",
        deposits: "Tiền nạp",
        withdrawals: "Tiền rút",
        bonus: "Tiền thưởng",
        deposit_transactions: "Giao dịch nạp tiền",
        filter_by: "Lọc theo",
        select_trading_id: "Chọn ID giao dịch",
        all: "ALL",
        date: "Ngày",
        account_id: 'Account ID',
        currency: "Tiền tệ",
        payment_mode: "Phương thức thanh toán",
        deposit_amount: "Số tiền nạp",
        status: 'Status',
        no_deposits_yet: "Chưa có tiền nạp",
        withdrawal_mode: "Phương thức rút tiền",
        withdrawal_amount: "Số tiền rút",
        action: "Hành động",
        view_more : "Xem thêm",
        no_withdrawals_yet: "Chưa rút tiền",
        bonus_amount: "Số tiền thưởng",
        pending : "Đang chờ xử lý",
        no_bonus_transactions_yet: "Chưa có giao dịch tiền thưởng",
        deposit_currency: "Đơn vị Tiền tệ nạp tiền",
        account_currency: 'Tiền tệ của tài khoản',
        address: 'Địa chỉ',
    },
    withdrawal: {
        kyc_req_msg: "Bắt buộc phải hoàn thành KYC trước khi yêu cầu rút tiền. Vui lòng gửi bằng chứng về địa chỉ bằng cách sử dụng phiếu hỗ trợ",
        Click_here: "Nhấp vào đây",
        or_email_to: 'hoặc email đến',
        with_step_heading: "Các bằng chứng địa chỉ sau đây được chấp nhận",
        one: "1",
        two: "2",
        three: "3",
        with_step_one: "Hóa đơn tiện ích",
        with_step_two: "Bảng sao kê ngân hàng",
        with_step_three: "Chứng từ thuế do Chính phủ cấp",
        note: "Lưu ý",
        note_info: "Bằng chứng về địa chỉ được phát hành trong không quá 4 tháng trở lại đây",
        ok: "OK",
        enable_2fa_msg: "Bắt buộc phải kích hoạt 2FA để tạo yêu cầu rút tiền. Vui lòng nhấp vào nút sau",
        click_to_enable: "Nhấn vào đây để bật",
        select_trading_id: "Chọn ID giao dịch",
        account_id: "ID tài khoản",
        account_type: "Loại tài khoản",
        platform: 'Nền tảng',
        leverage: "Đòn bẩy",
        currency: "Tiền tệ",
        free_margin: "Ký quỹ còn dư",
        note_info_two: "Nhập số tiền rút bằng Đơn vị tiền tệ cơ sở của Tài khoản Giao dịch của bạn.",
        amount: "Số tiền",
        mode_of_payment: "Phương thức thanh toán",
        create_transaction: "Tạo giao dịch",
        cancel: "Hủy",
        add_payment_method: "Thêm phương thức thanh toán",
        no_amount_available: "Không có sẵn tiền trong tài khoản này",
    },
    //components -> Shared
    account_dropdown:{
        select_account: "Chọn tài khoản",
    },
    footer: {
        legal_information: "Thông tin pháp lý",
        legal_information_info: "Sikhula Venture Capital (Pty) Ltd. được ủy quyền và quản lý bởi Cơ quan quản lý ngành tài chính Nam Phi (FSCA số 2017/315029/07).",
        risk_warning: "Cảnh báo rủi ro",
        risk_warning_info: "Giao dịch tiền tệ giao ngay liên quan đến rủi ro đáng kể và luôn có khả năng thua lỗ. Kết quả giao dịch của bạn có thể khác nhau. Bởi vì yếu tố rủi ro cao trong giao dịch thị trường ngoại hối, chỉ nên sử dụng các quỹ “rủi ro” thực sự trong giao dịch đó. Nếu bạn không có dư nguồn vốn để gánh chịu các thua lỗ, bạn không nên giao dịch trên thị trường ngoại hối. Không có hệ thống giao dịch “an toàn” nào từng được nghĩ ra và không ai có thể đảm bảo luôn có lợi nhuận hoặc tránh khỏi thua lỗ.",
    },
    header: {
        welcome: "Chào mừng bạn", 
        profile: 'Hồ sơ',
        request_callback: "Yêu cầu gọi lại",
        support_ticket: "Phiếu yêu cầu hỗ trợ",
        change_password: "Đổi mật khẩu",
        logout: "Đăng xuất",
    },
    pagination: {
        total_records: "Tổng số dữ liệu", 
    },
    side_bar: {
        dashboard: "Bảng điều khiển",
        manage_accounts: "Quản lý tài khoản",
        fund: "Nguồn vốn",
        bonus: "Tiền thưởng",
        become_a_partner: "Trở thành một đối tác",
        tools: "Các công cụ",
        bonus_and_promotions: 'Phần thưởng & Khuyến mãi',
    },
    success_box: {
        otp_varify: "Vui lòng nhập mã Pin một lần gồm 6 chữ số được hiển thị trong ứng dụng Google Authenticator.",
        cancel: "Hủy",
        submit: 'Gửi',
        trouble_with_2fa: "Gặp sự cố với mã xác thực hai yếu tố của bạn?",
        click_varify_with_email: "Bấm vào đây để xác minh bằng email",
        or: "HOẶC",
        click_here: "Nhấp vào đây",
        to_enable_2fa: "để kích hoạt 2FA của bạn và hoàn thành yêu cầu của bạn",
        take_me_back: "Đưa tôi trở lại",
    },
    tost_message: {
        varify_acc: "Vui lòng xác minh tài khoản của bạn để tạo tài khoản trực tiếp",
        click_to_begin: "Nhấn vào đây để bắt đầu quá trình xác minh",
    },
    proof_residence_alert: {
        you_have: "Bạn có",
        days_left_for_proof: "ngày còn lại để nộp bằng chứng cư trú.",
        click_here: "Nhấp vào đây",
        to_upload: "để tải lên",
    },
    closed_trades: {
        login: "Đăng nhập",
        order: "Lệnh",
        symbol: "Biểu tượng",
        volume: "Khối lượng",
        open_price: "Giá mở",
        open_time: "Thời gian mở",
        commission: "Phí hoa hồng",
        type: 'Loại',
        sl: "SL",
        tp: "TP",
        close_price: 'Giá đóng cửa',
        close_time: 'Thời gian đóng cửa',
        swap: 'Phí qua đêm',
        pnl: "PNL",
        comment: 'Bình luận',
        no_record_found: "Không tìm thấy dữ liệu",
    },
    open_trade: {
        order: 'Order',
        symbol: 'Symbol',
        type: 'Type',
        volume: "Khối lượng",
        open_price: "Giá mở",
        pnl: "PNL",
        no_record_found: "Không tìm thấy dữ liệu",
    },
}